import { render, staticRenderFns } from "./UpdateForum.vue?vue&type=template&id=7399840e&scoped=true"
import script from "./UpdateForum.vue?vue&type=script&lang=js"
export * from "./UpdateForum.vue?vue&type=script&lang=js"
import style0 from "./UpdateForum.vue?vue&type=style&index=0&id=7399840e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399840e",
  null
  
)

export default component.exports